// @flow

const routes = {
  signUp: '/',
  signIn: '/sign-in',
  recoverPassword: '/recover-password',
  changePassword: '/change-password',
  home: '/home',
  profile: '/profile',
  process: '/process',
  contract: '/contract',
  selfie: '/selfie',
  links: '/links',
  payment: '/payment',
  payphone: '/payphone',
  validation: '/validation',
  contractValidation: '/contract-validation',
  documentValidation: '/document-validation',
  paymentValidation: '/payment-validation',
  paymentRenovation: '/payment-renewal',
  dataValidation: '/data-validation',
};

export default routes;
